@use '@/styles/tokens' as *;

// Figma 1790:983884: label, code boxes and resend line, all centred, 20px apart.
.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-5);
  text-align: center;
}

.resend {
  margin: 0;
  font-size: $font-size-md;
  color: var(--text-disabled);
  text-align: center;
}

// "Resend code" — Figma 1790:985287 first run: Geist 14 / Medium / Text/Primary. Scoped under
// `.resend` to out-rank TextButton's own `.ant-btn-link` size and tone rules, hover included.
.resend :global(.ant-btn-link).resendButton {
  &,
  &:hover:not(:disabled),
  &:focus-visible:not(:disabled),
  &:active:not(:disabled) {
    font-size: $font-size-md;
    color: var(--text-primary);
  }
}

// "- N Attempts remaining" — same node, second run: Geist 14 / Regular / Text/Secondary.
.attempts {
  color: var(--text-secondary);
}

// The code field's own <FormField> (Figma "OTP field" 1790:990150): label, boxes and error 12px
// apart, the error at 14px, and no trailing margin — `.body`'s gap is the only space to the resend
// line.
.body > :first-child {
  gap: var(--space-3);
  margin-bottom: 0;

  [role='alert'] {
    font-size: $font-size-md;
  }
}
